import API from '../dataApi';

// -- Accounting: Financial Years -----------------------------------------------
export const getFinancialYears = (derasarId) => API.get('/financial-year', { params: { derasarId } });
export const createFinancialYear = (data) => API.post('/financial-year', data);
export const getFinancialYear = (id) => API.get(`/financial-year/${id}`);
export const closeFinancialYear = (id) => API.post(`/financial-year/${id}/close`);
export const lockFinancialYear = (id) => API.post(`/financial-year/${id}/lock`);
export const unlockFinancialYear = (id) => API.post(`/financial-year/${id}/unlock`);
